<nav id="mainMenu" #navbar class="navTracsa">
  <div class="logoSites">
    <div class="contentLogoMenuSites">
      <button
        class="menuBtnMobile"
        (click)="showMainMenuMobile()"
        aria-expanded="false"
        aria-label="Abrir menú de navegación"
        #buttonMenuMobile
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <a class="logo" routerLink="/" (click)="isMobile && closeMenu()">
        <div class="containerLogo">
          <img
            class="logoPrincipal"
            src="/general/logo.png"
            alt="Tracsa Cat"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </div>
      </a>
    </div>
    <div class="contentLinksMobile">
      <a
        class="iconLinksMobile"
        routerLink="/sucursales"
        aria-label="Tracsa sucursales"
        (click)="closeMenu()"
      >
        <i class="iconTracsa">
          <img
            src="/icons/map-pin_hover.svg"
            alt="icono sucursales"
            width="20"
            height="20"
            loading="lazy"
          />
        </i>
      </a>
      @if (false) {
        <a
          class="iconLinksMobile"
          target="_blank"
          href="https://wa.me/523316071921"
          aria-label="whatsapp tracsa"
        >
          <i class="iconTracsa"
            ><img
              src="/icons/message-circle_hover.svg"
              alt="icono whatsapp"
              width="20"
              height="20"
              loading="lazy"
          /></i>
        </a>
      }
      <a class="iconLinksMobile" href="tel:8005614944">
        <img
          src="/icons/phone-outgoing_hover.svg"
          alt="Teléfono Tracsa"
          width="20"
          height="20"
          loading="lazy"
        />
      </a>
      @if (th()) {
        <button
          class="brz"
          (click)="closeMenu(); menuCompanyMovil('th')"
          aria-label="Sitios tracsa"
          aria-expanded="false"
        >
          <img
            src="/icons/sitios_tracsa_ default.svg"
            alt="icono sitios tracsa"
            width="20"
            height="20"
          />
        </button>
      }
      @if (times()) {
        <button class="brz" (click)="menuCompanyMovil('times')" aria-expanded="false">
          <img src="/icons/noun_X_2172405.svg" alt="icono cerrar" />
        </button>
      }
    </div>
  </div>
  <div class="contentLinksNav" #contentLinksNav>
    <ul class="nav-list">
      <li class="nav-item" #itemNew>
        <a
          class="nav-link"
          id="linkNew"
          #linkNew
          (mouseenter)="!isMobile && openMegaMenuNew()"
          (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
          (click)="isMobile ? openMegaMenuNew() : closeMegaMenu()"
          [routerLink]="!isMobile ? '/productos' : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @if (!isMobile) {
            NUEVO
          } @else {
            <span>NUEVO</span>
            <div class="contentImage">
              <img src="/banners/chevron-right-white.svg" alt="left arrow" width="24" height="24" />
            </div>
          }
        </a>
      </li>
      <li class="nav-item" #itemUsed>
        <a
          class="nav-link"
          id="linkUsed"
          #linkUsed
          (mouseenter)="!isMobile && openMegaMenuUsed()"
          (mouseleave)="!isMobile && checkIsMegaMenuUsedOnHover()"
          (click)="isMobile ? openMegaMenuUsed() : closeMegaMenuUsed()"
          [routerLink]="!isMobile ? '/equipo-usado' : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @if (!isMobile) {
            USADO
          } @else {
            <span>USADO</span>
            <div class="contentImage">
              <img src="/banners/chevron-right-white.svg" alt="left arrow" width="24" height="24" />
            </div>
          }
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          (click)="isMobile && closeMenu()"
          routerLink="/equipo-en-renta"
          routerLinkActive="active"
          >RENTA</a
        >
      </li>
      <li class="nav-item" #itemSpare>
        <a
          class="nav-link"
          id="linkSpare"
          #linkSpare
          (mouseenter)="!isMobile && openMegaMenuSpare()"
          (mouseleave)="!isMobile && checkIsMegaMenuSpareOnHover()"
          (click)="isMobile ? openMegaMenuSpare() : closeMegaMenuSpare()"
          [routerLink]="!isMobile ? '/refacciones' : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @if (!isMobile) {
            REFACCIONES
          } @else {
            <span>REFACCIONES</span>
            <div class="contentImage">
              <img src="/banners/chevron-right-white.svg" alt="left arrow" width="24" height="24" />
            </div>
          }
        </a>
      </li>
      <li class="nav-item" #itemService>
        <a
          class="nav-link"
          id="linkService"
          #linkService
          (mouseenter)="!isMobile && openMegaMenuService(linkService)"
          (mouseleave)="!isMobile && checkIsMegaMenuServiceOnHover()"
          (click)="isMobile ? openMegaMenuService($event) : closeMegaMenuService()"
          [routerLink]="!isMobile ? '/servicio' : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @if (!isMobile) {
            SERVICIO
          } @else {
            <span>SERVICIO</span>
            <div class="contentImage">
              <img src="/banners/chevron-right-white.svg" alt="left arrow" width="24" height="24" />
            </div>
          }
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          (click)="isMobile && closeMenu()"
          routerLink="/marcas"
          routerLinkActive="active"
          >MARCAS</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          (click)="isMobile && closeMenu()"
          routerLink="/promociones"
          routerLinkActive="active"
          >PROMOCIONES</a
        >
      </li>
      <li class="nav-item" #itemDS>
        <a
          class="nav-link"
          id="linkDS"
          #linkDS
          (mouseenter)="!isMobile && openMegaMenuDS(linkDS)"
          (mouseleave)="!isMobile && checkIsMegaMenuDSOnHover()"
          (click)="isMobile ? openMegaMenuDS($event) : closeMegaMenuDS()"
          [routerLink]="!isMobile ? '/soluciones-digitales' : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          @if (!isMobile) {
            SOLUCIONES DIGITALES
          } @else {
            <span>SOLUCIONES DIGITALES</span>
            <div class="contentImage">
              <img src="/banners/chevron-right-white.svg" alt="left arrow" width="24" height="24" />
            </div>
          }
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          (click)="isMobile && closeMenu()"
          routerLink="/industrias"
          routerLinkActive="active"
          >INDUSTRIAS</a
        >
      </li>
    </ul>
    <div class="downBar">
      <button class="btn" (click)="showMenuPurchase()">
        <span>COMPRA EN LÍNEA</span>
        <div class="contentImage">
          <img src="/general/chevron-right-gray.svg" alt="left arrow" width="24" height="24" />
        </div>
      </button>
      @if (false) {
        <a routerLink="/cat-card" (click)="isMobile && closeMenu()">CAT CARD</a>
      }
      <a routerLink="/cuenta-comercial-cat" (click)="isMobile && closeMenu()"
        >CUENTA COMERCIAL CAT</a
      >
      <a routerLink="/financiamiento" (click)="isMobile && closeMenu()">FINANCIAMIENTO</a>
      <a routerLink="/sucursales" (click)="isMobile && closeMenu()">SUCURSALES</a>
      <a routerLink="/contacto" (click)="isMobile && closeMenu()">CONTACTO</a>
    </div>
  </div>
  @if (false) {
    <div class="inputSearch">
      <input
        #inputSearch
        type="text"
        placeholder="¿Qué estás buscando?"
        (keyup)="onKeyUp($event)"
        (keyup.enter)="goToSearch(inputSearch.value)"
        name="search"
      />
      @if (inputSearch.value !== '') {
        <button class="btnDelete" (click)="deleteText()"></button>
      }
      <button class="btnSearch" (click)="goToSearch(inputSearch.value)"></button>
      <div class="resultsInput" #resultsInput>
        @if (results$ | async; as results) {
          @for (result of results; track $index) {
            <a [routerLink]="result.url" class="linkResult">{{ result.name }}</a>
          }
        }
      </div>
    </div>
  }
</nav>
